import { User } from '@/api/auth';
import { ScratchGameApi } from '@/api/cms/scratchGame';
import { Lootbox } from '@/api/common';
import { isPromoAvailableDate } from '@/helpers/dateTime';
import { someGroupMember, USER_GROUP } from '@/helpers/user';

export const SCRATCH_GAME_RESTRICTED_GROUPS = [
  USER_GROUP.BA,
  USER_GROUP.BR,
  USER_GROUP.DEV_TEST,
  USER_GROUP.VIPBA,
];

export const LOOTBOX_SCRATCH_TITLES = ['Scratch_game', 'scratch_game'];

export const isScratchLootbox = (lootbox: Lootbox) =>
  LOOTBOX_SCRATCH_TITLES.some((LOOTBOX_SCRATCH_TITLES) =>
    lootbox.title.includes(LOOTBOX_SCRATCH_TITLES)
  );

export const checkIsScratchGameAvailable = (
  data: ScratchGameApi | null,
  user?: User
) => {
  if (!data || !data.start || !data.end) {
    return false;
  } else {
    return (
      !someGroupMember(SCRATCH_GAME_RESTRICTED_GROUPS)(user) &&
      isPromoAvailableDate(data.start, data.end)
    );
  }
};
